import { router } from '../router'
import { portalapi } from 'src/helpers/axios'
import { ErrorService } from "../helpers/errorplugin"
const $log = ErrorService
const state = {
    user: null, 
    accessToken: "", 
    refreshToken: "",
    site: null,
    account: null };

const mutations= {
  setRefreshToken: function(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  setAccessToken: function(state, accessToken) {
    state.accessToken = accessToken;
  },
  setSite: function(state, site) {
    state.site = site;
  },
  loginSuccess: function(state, user) {
    state.user = user;
  },
  loginFailure: function(state) {
    state.user = null;
    state.refreshToken = "";
    state.accessToken = "";    
  },
  logout: function(state){
    state.user = null;
    state.refreshToken = "";
    state.accessToken = "";    
  },
  // delete all auth and user information from the state
  clearUserData: function(state) {
    state.refreshToken = "";
    state.accessToken = "";
    state.user = {};
  },
  setAccount: function(state, account) {
    state.account = account;
  },
  reset: function(state, type){
    if ( type != 'main') {
      state.refreshToken = "";
      state.accessToken = "";
      state.user = {};
    }
  }
}
  
const actions = {

  logIn: ({dispatch, commit }, payload) => {

    const loginUrl = "jwt/create";    
    
    return new Promise((resolve, reject) => {

      const loginUrl = "jwt/create";   
    
      portalapi.post(loginUrl, payload).then(        
        async( response ) => {
            $log.onDebug("logged in okay")
            commit("setRefreshToken", response.data.refresh);
            commit("setAccessToken", response.data.token);
            commit("loginSuccess", response.data.user );  
            resolve(response)
            dispatch("getAccount")       
            router.push('/account/info')             
        },
        async (error) => { 
            $log.onDebug("login failure:" + JSON.stringify(error))
            commit("loginFailure", error);
            await dispatch('alert/error', error, { root: true });
            reject(error)
        }
      )
    })
  },
  
  logout({commit}) {
    commit("logout")
    router.push({ name: "Login" })
  },

  getSite: ({commit}) => {
    return new Promise((resolve, reject) => {
      portalapi.get("open/site/info").then(
        async(response) => {
          commit("setSite", response.data)
          resolve(response)
        },
        async (error) => { 
            $log.onDebug("site retrieval failure:" + JSON.stringify(error))
            await dispatch('alert/error', error, { root: true });
            reject(error)
        }
      )
    })
  },
  getAccount: ({commit}) => {
    return new Promise((resolve, reject) => {
      portalapi.get('/myaccount/info').then(
        (response) => {
          commit("setAccount", response.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}
  
const getters = {
  loggedInUser: state => state.user,
  isAuthenticated: state => {
    if(state.accessToken != "") {
      return true;
    } else {
      return false;
    }
  },
  accessToken: state => state.accessToken,
  refreshToken: state => state.refreshToken,
  site: state => state.site,
  account: state => state.account
}
  
export const account = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
  
  


